document.addEventListener("DOMContentLoaded", function () {
  // Ne rien faire si on est sur une box d'abonnement
  if (
  document.body.classList.contains("product-3-box") ||
  document.body.classList.contains("product-6-box") ||
  document.body.classList.contains("product-abonnement-mensuel") ||
  document.body.classList.contains("product-abonnement-bimestriel") ||
  window.location.href.includes('/products/footi-neon')
) return;

  // Sélection des éléments HTML déjà présents dans le buy-buttons.liquid
  const input = document.getElementById("club-selection");
  const suggestions = document.getElementById("club-suggestions");
  const selectedClubsContainer = document.getElementById("selected-clubs");
  const inputHidden = document.getElementById("club-exclusions-hidden");

  // On arrête si un des éléments nécessaires n'est pas présent
  if (!input || !suggestions || !selectedClubsContainer || !inputHidden) return;

  // Liste des clubs proposés
  const clubs = [
   "Allemagne", "Arabie Saoudite", "Argentine", "Australie", "Autriche", "Belgique", "Bolivie", "Bosnie-Herzégovine", "Brésil", "Bulgarie",
"Cameroun", "Canada", "Chili", "Chine", "Colombie", "Corée du Sud", "Costa Rica", "Croatie", "Danemark", "Égypte",
"Équateur", "Espagne", "États-Unis", "Finlande", "France", "Ghana", "Grèce", "Guinée", "Honduras", "Hongrie",
"Irak", "Iran", "Irlande", "Islande", "Israël", "Italie", "Japon", "Kazakhstan", "Kenya", "Kosovo",
"Maroc", "Mexique", "Nigeria", "Norvège", "Nouvelle-Zélande", "Ouzbékistan", "Paraguay", "Pays-Bas", "Pérou", "Pologne",
"Portugal", "Qatar", "République tchèque", "Roumanie", "Russie", "Sénégal", "Serbie", "Slovaquie", "Slovénie", "Suède",
"Suisse", "Tunisie", "Turquie", "Ukraine", "Uruguay", "Venezuela", "Pays de Galles", "Écosse", "Afrique du Sud", "Algérie",
"Arménie", "Bélarus", "Cap-Vert", "Côte d'Ivoire", "Curacao", "El Salvador", "Estonie", "Géorgie", "Jamaïque", "Liban",
"Lituanie", "Luxembourg", "Macédoine du Nord", "Malaisie", "Mali", "Malte", "Monténégro", "Namibie", "Niger", "Oman",
"Panama", "Philippines", "RD Congo", "Slovénie", "Syrie", "Tadjikistan", "Thaïlande", "Trinité-et-Tobago", "Viêt Nam", "Zambie",
"Paris Saint-Germain", "Olympique de Marseille", "AS Monaco", "Lyon", "Lille", "Rennes", "Nice", "Lens", "Strasbourg", "Toulouse",
"Reims", "Montpellier", "Brest", "Nantes", "Clermont", "Lorient", "Metz", "Le Havre", "Auxerre", "Ajaccio",
"Manchester United", "Manchester City", "Liverpool", "Chelsea", "Arsenal", "Tottenham Hotspur", "Newcastle United", "Aston Villa", "West Ham United", "Everton",
"Brighton & Hove Albion", "Brentford", "Crystal Palace", "Fulham", "Wolverhampton", "Bournemouth", "Nottingham Forest", "Burnley", "Sheffield United", "Luton Town",
"Bayern Munich", "Borussia Dortmund", "RB Leipzig", "Bayer Leverkusen", "Eintracht Francfort", "Union Berlin", "SC Freiburg", "VfL Wolfsburg", "Borussia Mönchengladbach", "Mainz 05",
"Hoffenheim", "Augsbourg", "Werder Brême", "VfB Stuttgart", "Bochum", "Heidenheim", "Darmstadt", "Hansa Rostock", "Greuther Fürth", "Nuremberg",
"Real Madrid", "FC Barcelone", "Atlético Madrid", "Sevilla FC", "Real Sociedad", "Real Betis", "Villarreal CF", "Athletic Bilbao", "Valencia CF", "Celta Vigo",
"Getafe", "Osasuna", "Mallorca", "Granada", "Alavés", "Cadix", "Las Palmas", "Levante", "Espanyol", "Rayo Vallecano",
"Juventus", "Inter Milan", "AC Milan", "Napoli", "AS Roma", "Lazio", "Atalanta", "Fiorentina", "Torino", "Bologna",
"Sassuolo", "Udinese", "Empoli", "Spezia", "Salernitana", "Lecce", "Verona", "Cagliari", "Genoa", "Sampdoria",
"AS Saint-Étienne", "Girondins de Bordeaux", "Racing Club de Lens", "Red Star FC", "SD Huesca", "Deportivo La Coruna", "Real Zaragoza", "Palermo", "Parma", "Brescia",
"Hambourg SV", "Schalke 04", "Hanovre 96", "1860 Munich", "St Pauli", "Leeds United", "Cardiff City", "Swansea City", "Derby County", "Queens Park Rangers",
"Anderlecht", "Club Brugge", "Standard Liège", "Celtic", "Rangers", "Fenerbahçe", "Galatasaray", "Besiktas", "Shakhtar Donetsk", "Dynamo Kyiv",
"Zenit Saint-Pétersbourg", "Spartak Moscou", "CSKA Moscou", "Ajax Amsterdam", "Feyenoord", "PSV Eindhoven", "FC Porto", "SL Benfica", "Sporting CP", "PAOK Salonique",
"AEK Athènes", "Crvena Zvezda", "Partizan Belgrade", "Dinamo Zagreb", "Steaua Bucarest", "Rapid Vienne", "Young Boys", "FC Bâle", "Copenhague", "Legia Varsovie",
"Angleterre", "Esperance Tunis", "Inter Miami", "New York City FC", "Santos Laguna", "RB Salzburg"

  ];

  let selectedClubs = [];

  function updateSelectedClubs() {
    selectedClubsContainer.innerHTML = "";
    inputHidden.value = selectedClubs.join(", ");
    selectedClubs.forEach(club => {
      const tag = document.createElement("span");
      tag.textContent = club;
      tag.classList.add("club-tag");
      const removeBtn = document.createElement("button");
      removeBtn.type = "button";
      removeBtn.textContent = "x";
      removeBtn.addEventListener("click", () => {
        selectedClubs = selectedClubs.filter(c => c !== club);
        updateSelectedClubs();
      });
      tag.appendChild(removeBtn);
      selectedClubsContainer.appendChild(tag);
    });
  }

  input.addEventListener("input", function () {
    const value = input.value.toLowerCase();
    suggestions.innerHTML = "";
    if (value.length === 0) {
      suggestions.classList.add("hidden");
      return;
    }

    const filtered = clubs.filter(club => club.toLowerCase().includes(value));
    filtered.forEach(club => {
      const li = document.createElement("li");
      li.textContent = club;
      li.addEventListener("click", () => {
        if (!selectedClubs.includes(club)) {
          selectedClubs.push(club);
          updateSelectedClubs();
        }
        input.value = "";
        suggestions.classList.add("hidden");
      });
      suggestions.appendChild(li);
    });

    suggestions.classList.remove("hidden");
  });
});

